import React, { useState, useEffect } from "react";
import { Container, Row, Col, Button, Table, Form } from "react-bootstrap";
import CustomFormCheck from "utils/CustomFormCheck";
import CustomTooltip from "utils/CustomTooltip";
import jsDig from "utils/jsDig";

export default function AlertsGroup(props) {
  return (
    <>
      <div className="alerts-group pb-3">
        {props.service == "seo" ? (
          <p className="text-info f22 visby-bold green">{props.platform.platformName}</p>
        ) : (
          <p className="text-info f22 visby-bold">{props.platform.platformName}</p>
        )}

        <div className={props.platform.platformName === "Google Shopping" ? "alerts alert-special" : props.service == "seo" ? "alerts alerts-seo" : "alerts"}>
          {props.platform.alerts.map((alert) => {
            return (
              <div key={alert.name} className="alert-box text-primary p-3">
                <div style={{ paddingLeft: "2px" }} className="d-flex">
                  <CustomFormCheck
                    id={`${alert.name}_search`}
                    name={`[alerts][${props.service}][${alert.name}][enabled]`}
                    label={`${alert.title}`}
                    sendUncheckedValue
                    defaultChecked={jsDig([alert.name], props.scripts) == "1" ? true : false}
                    static
                  />
                  <CustomTooltip faClass="far fa-question-circle pt-1 pl-2" message={alert.desc} inline={true} />
                </div>
                {alert.options && (
                  <div className="alert-options pt-2">
                    <Table responsive>
                      <tbody>
                        {alert.options.map((option) => {
                          return (
                            <tr key={`${alert.name}-${option.name}`}>
                              <td className="pl-0">{option.title}</td>
                              <td className="pl-0">
                                <Form.Control
                                  size="sm"
                                  name={`[alerts][${props.service}][${alert.name}][options][${option.name}]`}
                                  placeholder={option.placeholder}
                                  style={{ width: "158px" }}
                                  defaultValue={jsDig([alert.name, option.name], props.scriptVariables)}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}
